import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class UuidService {
  private readonly isBrowser = isPlatformBrowser(this.platformId);

  constructor(@Inject(PLATFORM_ID) private readonly platformId: Object) {}

  generate(): string {
    let bytes: Uint8Array;

    if (this.isBrowser && typeof crypto !== 'undefined')
      bytes = crypto.getRandomValues(new Uint8Array(16));
    else {
      // eslint-disable-next-line no-eval
      const nodeCrypto = eval('require')('crypto');
      bytes = new Uint8Array(nodeCrypto.randomBytes(16));
    }

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes).map((b) => b.toString(16).padStart(2, '0'));
    return `${hex[0]}${hex[1]}${hex[2]}${hex[3]}-${hex[4]}${hex[5]}-${hex[6]}${hex[7]}-${hex[8]}${hex[9]}-${hex[10]}${hex[11]}${hex[12]}${hex[13]}${hex[14]}${hex[15]}`;
  }
}
